import { Nullable } from 'primereact/ts-helpers';
import { Site } from './Site';
import { Class } from './Class';
import { Grade } from './Grade';

export interface ReportsFilter {
  sites: Site;
  classes: Class[];
  grades: Grade[];
  roadmaps: { id: string; name: string };
  skillGrades: {
    code: string;
    name: string;
  }[];
  dates: Nullable<(Date | null)[]>;
}

export const reportsFilterInitialState = {
  sites: { id: '', name: '' },
  classes: [],
  grades: [],
  roadmaps: { id: '', name: '' },
  skillGrades: [],
  dates: [],
};
